import React from 'react'
import { transition } from '../../../core/lib/transition/transition'

 const About = () => {
  return (
    <div className="text-6xl text-black">About</div>
  )
}

export default transition(About)